import { AInput } from "@/admin/form/Fields.tsx";
import { WTextField } from "@/components/forms/WTextField.tsx";
import { useState } from "react";

export function SuspensionReasonTextBlock({ value, onChange }: { value: string; onChange: (value: string) => void }) {
    const [reason, setReason] = useState(value);

    function onReason(value: string) {
        setReason(value);
        onChange(value);
    }

    return (
        <WTextField
            aria-label="Reason"
            // XXX : in Change billing account status modal it catches focus if Suspended is selected
            // autoFocus
            onChange={onReason}
            description="Enter reason why account will be suspended. Keep in mind that the reason will be shown to user also."
        >
            <AInput value={reason ?? ""} />
        </WTextField>
    );
}
